import React from "react";

const BillAddressFake = () => {
  return (
    <div className="container">
      <div className="bill-address-fake">
        <div className="skeleton bill-address-fake--address" />
        <div className="skeleton bill-address-fake--address" />
        <div className="skeleton bill-address-fake--link" />
      </div>
      <style jsx>{`
        .bill-address-fake {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
          width: 100%;
          &--address {
            height: 1rem;
            width: 33%;
          }
          &--link {
            height: 1rem;
            width: 30%;
            margin-top: 0.25rem;
          }
        }
      `}</style>
    </div>
  );
};

export default BillAddressFake;
